module.exports = __webpack_public_path__ + "static/iwonder-b7265f8904f33977580ddbafd38d3fa9.png";